import * as React from 'react'
import './index.scss'
import { RELEASED_PAGE } from './htmlComponents'

function ReleaseNotes() {
    return (
        <div>
            <div
                className="content"
                dangerouslySetInnerHTML={{
                    __html: RELEASED_PAGE,
                }}
            />
        </div>
    )
}

export default ReleaseNotes
